// extracted by mini-css-extract-plugin
export default {"doctors-list":"AdminProviderList_doctors-list__mTuAQ","DoctorslistContainer":"AdminProviderList_DoctorslistContainer__85E3W","loader":"AdminProviderList_loader__h-PcX"};